import { BitrixVue } from 'ui.vue';

BitrixVue.component('CatalogModal', {
data() {
return { selectedDoor: null };
},
methods: {
showModal(modal) {
this.$refs[modal].open();
},
},
props: ['items'],
template: `
<ConfigBlockWrap>
	<ButtonModal class="mt-24" buttonText="Посмотреть весь каталог" v-on:openModal="showModal('catalogModal')" />
	<ui-modal ref="catalogModal" transition="fade" title="Каталог дверей" class="catalog-modal config-modal" size="large">
		<div class="catalog-modal__wrap">
			<DoorItem 
				v-for="(door, index) of this.items" 
				:image="door.image" 
				:title="door.title" 
				:price="door.price"
				:sizes="door.sizes" 
				:availability="door.availability" 
				:class="{active: selectedDoor === door.id}" 
				:key="door.id"
				v-on:setActive="selectedDoor = door.id" 
				:activeDoor="selectedDoor" 
				:doorId="door.id" />
		</div>
	</ui-modal>
</ConfigBlockWrap>

`,
});